import { IconWrapper } from "@insite/mobius/Icon";
import { MenuPresentationProps } from "@insite/mobius/Menu";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import getColor from "@insite/mobius/utilities/getColor";
import RecursivePartial from "@insite/mobius/utilities/RecursivePartial";
import { colorStrings } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

export const menu: RecursivePartial<{
    defaultProps?: MenuPresentationProps | undefined;
}> = {
    defaultProps: {
        menuItemTypographyProps: {
            transform: "none",
            color: colorStrings.primaryMain,
        },
        cssOverrides: {
            menuItem: css`
                a {
                    span {
                        color: ${getColor(colorStrings.primaryMain)};
                        padding-block: 16px;

                        & + span {
                            top: 50%;
                            transform: translateY(-50%);
                        }
                    }
                    &:hover {
                        background: ${getColor(colorStrings.primaryMain)};

                        ${TypographyStyle} {
                            color: ${getColor(colorStrings.commonGlobalWhite)};
                        }

                        ${IconWrapper} {
                            color: ${getColor(colorStrings.commonGlobalWhite)};
                        }
                    }
                }
            `,
        },
    },
};
